import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { withHighContrastMode } from 'react-a11y-utils';

import { LinkExternal } from 'cstar-react-primitives/lib/redux-form';
import headerMessages from './headerMessages';
import { getStaticMediaURL } from '../app/bootstrap';

export const HeaderImageLink = (props) => {
    const {
        intl, brandUrl, brandName, brandCode, highContrastMode
    } = props;
    const imgLinkProps = {
        cssClass: 'header__img',
        url: brandUrl,
        atts: {
            'aria-label': intl.formatMessage(headerMessages.imageAriaLabel, { brandName })
        }
    };
    const imgLinkPropsInHighContrastMode = {
        url: brandUrl,
        atts: {
            'aria-label': intl.formatMessage(headerMessages.imageAriaLabel, { brandName })
        }
    };
    const linkCopy = intl.formatMessage(headerMessages.linkText, { brandName });
    const logoSrc = intl.formatMessage(headerMessages.logoSrc, { brandCode });
    const imgUrl = `${getStaticMediaURL()}/images/${brandCode}/${logoSrc}`;
    const imgProps = {
        src: imgUrl,
        className: 'header__img',
        alt: linkCopy,
        title: linkCopy
    };
    return highContrastMode
        ? <div className=' header__logo-high-contrast-mode-container'><LinkExternal {...imgLinkPropsInHighContrastMode}>{ imgProps.alt }</LinkExternal></div>
        
        : <LinkExternal {...imgLinkProps}><img {...imgProps} /></LinkExternal>;
};

HeaderImageLink.defaultProps = {
    highContrastMode: null
};

HeaderImageLink.propTypes = {
    intl: intlShape.isRequired,
    brandUrl: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    brandCode: PropTypes.string.isRequired,
    highContrastMode: PropTypes.string

};

export default withHighContrastMode(injectIntl(HeaderImageLink));
